import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../locales/translations';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const FAQ = () => {
  const { language } = useLanguage();
  const text = t[language].faq;
  const [openIdx, setOpenIdx] = useState(0);

  // Reset open item when language changes
  useEffect(() => {
    setOpenIdx(0);
  }, [language]);

  return (
    <section id="faq" className="py-16 sm:py-24 bg-[#0f0f13] overflow-hidden border-t border-white/5">
      <div className="container mx-auto px-4 sm:px-6 max-w-4xl">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-3xl sm:text-4xl md:text-5xl font-bold text-white text-center mb-12"
        >
          {text.title}
        </motion.h2>

        <div className="grid sm:grid-cols-2 gap-4">
          {text.questions.map((faq, idx) => (
            <motion.div
              key={`${language}-${idx}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: (idx % 2) * 0.1 }}
              className={`rounded-2xl border overflow-hidden transition-colors duration-300 h-fit ${
                openIdx === idx ? 'border-orange-500/30 bg-[#141420]' : 'border-white/5 bg-[#1a1a24]'
              }`}
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? -1 : idx)}
                className="w-full px-5 py-4 flex items-center justify-between text-left gap-4"
              >
                <span className="text-base font-bold text-white leading-snug">{faq.q}</span>
                <motion.div
                  animate={{ rotate: openIdx === idx ? 45 : 0 }}
                  transition={{ duration: 0.3 }}
                  className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center border transition-colors ${
                    openIdx === idx
                      ? 'bg-orange-500/20 border-orange-500/40 text-orange-400'
                      : 'bg-white/5 border-white/10 text-gray-500'
                  }`}
                >
                  <SafeIcon icon={FiIcons.FiPlus} className="text-sm" />
                </motion.div>
              </button>

              <AnimatePresence>
                {openIdx === idx && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.35, ease: 'easeInOut' }}
                    className="overflow-hidden"
                  >
                    <div className="px-5 pb-5 text-gray-400 text-sm leading-relaxed border-t border-white/5 pt-3">
                      {faq.a}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;